import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { DrfPaginatedResponse } from '../../../core/models/api.model';
import type { AssembleeGenerale } from '../../../core/models/gouvernance/assemblee-generale.model';
import type { AgListQuery, AgProvider } from '../../performance/dividendes/ag-provider.port';
import { AssembleeGeneraleService } from './assemblee-generale.service';

/**
 * Adaptateur du port `AG_PROVIDER` : implémente les lectures d'assemblées générales attendues
 * par Dividendes (Performance) en déléguant au service du module Gouvernance (audit R-33).
 * Câblé au composition root (`app.config`). N'importe le port qu'en `type` : le seul lien
 * runtime Gouvernance ↔ Performance est le binding du token dans `app.config`.
 */
@Injectable()
export class AgProviderAdapter implements AgProvider {
    private readonly agService = inject(AssembleeGeneraleService);

    list(query: AgListQuery): Observable<DrfPaginatedResponse<AssembleeGenerale>> {
        return this.agService.list(query);
    }

    retrieve(id: string): Observable<AssembleeGenerale> {
        return this.agService.retrieve(id);
    }
}
